import {MessageProps} from "../types/messages";
import {getSetting} from "../utils/settings";
import {ContactSuggestion, ContentSuggestion} from "../types/data";

export async function getContact(id: number): Promise<ContactSuggestion> {
    const response = await fetch('/wp-json/chat-bot/v1/contact?id=' + id, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': getSetting('wp.nonce'),
        }
    });

    const data = await response.json();

    return data as ContactSuggestion;
}

export async function getContent(id: number): Promise<ContentSuggestion> {
    const response = await fetch('/wp-json/chat-bot/v1/content?id=' + id, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': getSetting('wp.nonce'),
        }
    });

    const data = await response.json();

    return data as ContentSuggestion;
}

export async function destroyHistory(): Promise<boolean> {
    const response = await fetch('/wp-json/chat-bot/v1/destroy', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': getSetting('wp.nonce'),
        }
    });

    return response.status < 400;
}

export async function sendMessage(message: string): Promise<MessageProps> {
    const response = await fetch('/wp-json/chat-bot/v1/message', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': getSetting('wp.nonce'),
        },
        body: JSON.stringify({
            url: window.location.href,
            text: message
        }),
    });

    const data = await response.json();

    if ( data.response ) {
        return {
            sender: 'bot',
            text: data.response.message,
            type: data.response.type,
            data: data.response.data
        };
    }
    else {
        const errorMessage = getSetting( 'error_messages.' + data.code ) ?? getSetting( 'error_messages.fallback' );

        return {
            sender: 'bot',
            text: errorMessage,
            type: 'error',
            data: null
        }
    }
}

export async function submitForm( route: string, payload: Record<string, unknown> ): Promise<boolean> {
    const response = await fetch(`/wp-json/chat-bot/v1/${route}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-WP-Nonce': getSetting('wp.nonce'),
        },
        body: JSON.stringify(payload),
    });

    return response.status < 400;
}

